import React from 'react'
import { MenuItem } from '@material-ui/core'
import { StyledPaper, StyledNoOption } from './styled'
import { IOption } from '../../types/common'
interface ISluglineSelectList {
  options: IOption[]
  handleSelect: (label: string) => void
  selected: number
  loadingProcesses: number
}

export const SluglineSelectList: React.FC<ISluglineSelectList> = ({
  options,
  handleSelect,
  selected,
  loadingProcesses,
}) => (
  <StyledPaper square>
    {options.length ? (
      options.map(({ label }, i) => (
        <MenuItem
          component="div"
          key={i}
          selected={i === selected}
          onClick={() => handleSelect(label)}
        >
          {label}
        </MenuItem>
      ))
    ) : (
      <StyledNoOption color="textSecondary">
        {!!loadingProcesses ? 'Loading...' : 'No options'}
      </StyledNoOption>
    )}
  </StyledPaper>
)
